<p-listbox *ngIf="!loadingDevices && !isServerError"
    [options]="devices"
    [(ngModel)]="selectedDevice"
    optionLabel="name"
    [filter]="true"
    [listStyle]="{'max-height': '220px'}"
    (onChange)="notifyChange()">
    <ng-template let-device pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-tablet"></i>
          <div>{{ device.name }}</div>
      </div>
  </ng-template>
</p-listbox>

<p-panel *ngIf="!loadingDevices && isServerError" [style]="{ height: '300px'}">
  <p-messages
    [(value)]="messages" [showTransitionOptions]="'500ms'" [enableService]="false" [closable]="false"/>
</p-panel>

<p-panel *ngIf="loadingDevices" [style]="{height: '300px'}">
  <p>Cargando equipos</p>
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }" />
</p-panel>


